export enum VatRatesSortProperty {
  Name = 'name',
  Priority = 'priority',
}
